import IndigoLoginError, {
    IndigoLoginErrorType,
} from 'communication/IndigoLoginError';
import { LoginErrorState, LoginErrorType } from './store/LoginState';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyError = any;

export const buildSystemError: (innerError: AnyError) => LoginErrorState = (
    innerError
) => ({
    type: LoginErrorType.SYSTEM_ERROR,
    message: 'A system error has occurred, please try again.',
    innerError,
});

export const buildInvalidCredentialsLoginError: (
    innerError: AnyError
) => LoginErrorState = (innerError) => ({
    type: LoginErrorType.USER_ACTION_ERROR,
    message: 'Username or password is incorrect, please try again.',
    innerError,
});

export const buildMissingCredentialsLoginError: (
    innerError: AnyError
) => LoginErrorState = (innerError) => ({
    type: LoginErrorType.USER_ACTION_ERROR,
    message: 'Please enter your username and password.',
    innerError,
});

export const buildNotAuthorizedLoginError: (
    innerError: AnyError
) => LoginErrorState = (innerError) => ({
    type: LoginErrorType.USER_CONFIGURATION_ERROR,
    title: 'Unauthorized Access',
    message:
        'Your account is not authorized to use Indigo. If this is a mistake, please contact your Instinet rep or email your regional support group.',
    innerError,
});

export const buildRestrictedIpLoginError: (
    innerError: AnyError
) => LoginErrorState = (innerError) => ({
    type: LoginErrorType.USER_CONFIGURATION_ERROR,
    title: 'Unexpected Login Location',
    message:
        'We noticed that your account has been logged in from an unexpected IP address. If this is a mistake, please contact your Instinet rep or email your regional support group.',
    innerError,
});

type LoginErrorMap = {
    [key in IndigoLoginErrorType]: (err: AnyError) => LoginErrorState;
};

const LOGIN_ERROR_MAP: LoginErrorMap = {
    [IndigoLoginErrorType.GENERIC_LOGIN_ERROR]: buildSystemError,
    [IndigoLoginErrorType.INVALID_CREDENTIALS_LOGIN_ERROR]:
        buildInvalidCredentialsLoginError,
    [IndigoLoginErrorType.MISSING_CREDENTIALS_LOGIN_ERROR]:
        buildMissingCredentialsLoginError,
    [IndigoLoginErrorType.NOT_AUTHORIZED_LOGIN_ERROR]:
        buildNotAuthorizedLoginError,
    [IndigoLoginErrorType.RESTRICTED_IP_LOGIN_ERROR]:
        buildRestrictedIpLoginError,
};

export function mapLoginRequestError(error: IndigoLoginError): LoginErrorState {
    if (!error || !error.type || !LOGIN_ERROR_MAP[error.type]) {
        return buildSystemError(error);
    }
    return LOGIN_ERROR_MAP[error.type](error) || buildSystemError(error);
}
